"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EEOQuestionLabel = void 0;
var React = require("react");
require("./EEOQuestionLabel.css");
var EEOQuestionLabel = (function (_super) {
    __extends(EEOQuestionLabel, _super);
    function EEOQuestionLabel(props) {
        return _super.call(this, props) || this;
    }
    EEOQuestionLabel.prototype.render = function () {
        var _a = this.props, questionLabel = _a.questionLabel, questionTag = _a.questionTag;
        return (React.createElement("label", { id: questionTag, htmlFor: questionTag, className: "p-text p-f-sz-md p-t-default p-f-w-n" }, questionLabel));
    };
    EEOQuestionLabel.defaultProps = {
        questionLabel: '',
        questionTag: '',
        showLabel: true
    };
    return EEOQuestionLabel;
}(React.Component));
exports.EEOQuestionLabel = EEOQuestionLabel;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["EEOQuestionLabel"] = undefined;


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/8b1685a0cde68c49/src/.tmp/EEOQuestionLabel/EEOQuestionLabel.js
// module id = 777
// module chunks = 0